var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCountryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21429 14.1803C3.27127 14.6587 2 15.4534 2 16.3529C2 17.8149 5.35786 19 9.5 19C13.6421 19 17 17.8149 17 16.3529C17 15.4534 15.7287 14.6587 13.7857 14.1803M8.92799 16.5434L4.68557 8.26798C2.96273 4.90733 5.55102 1 9.5 1C13.449 1 16.0373 4.90733 14.3144 8.26798L10.072 16.5434C9.84034 16.9953 9.15965 16.9953 8.92799 16.5434ZM11.6429 6.29412C11.6429 7.46366 10.6835 8.41177 9.5 8.41177C8.31653 8.41177 7.35714 7.46366 7.35714 6.29412C7.35714 5.12457 8.31653 4.17647 9.5 4.17647C10.6835 4.17647 11.6429 5.12457 11.6429 6.29412Z",
    stroke: "url(#paint0_linear_1_121)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_121",
    x1: 2,
    y1: 10,
    x2: 17,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryIcon);
export default __webpack_public_path__ + "static/media/CountryIcon.daf4bd95b3e824261030897aaeb16c6c.svg";
export { ForwardRef as ReactComponent };